module.exports = __webpack_public_path__ + "img/精细化路长制巡查及监督管理平台V1.0.7658e6d1.jpg";